// RouteLink.js
import React, { Suspense } from "react";
import { Navigate } from "react-router-dom";
import QuotationPrint from "./Pages/Quotation/QuotationPrint";

// Lazy load components for code splitting
const LoginPage = React.lazy(() => import("./Pages/Login/LoginPage"));
const DashboardLayout = React.lazy(() => import("./Layout/DashboardLayout"));
const DashboardHome = React.lazy(() =>
  import("./Pages/Dashboard/DashboardHome")
);
const PrivateRoute = React.lazy(() => import("./Utilities/PrivateRoute"));
const ItemGroup = React.lazy(() => import("./Pages/ItemGroup/ItemGroup"));
const AddItemGroup = React.lazy(() => import("./Pages/ItemGroup/AddItemGroup"));
const Unit = React.lazy(() => import("./Pages/Unit/Unit"));
const AddUnit = React.lazy(() => import("./Pages/Unit/AddUnit"));
const Item = React.lazy(() => import("./Pages/Item/Item"));
const AddItem = React.lazy(() => import("./Pages/Item/AddItem"));
const Party = React.lazy(() => import("./Pages/Party/Party"));
const AddParty = React.lazy(() => import("./Pages/Party/AddParty"));
const Terms = React.lazy(() => import("./Pages/Terms/Terms"));
const AddTerms = React.lazy(() => import("./Pages/Terms/AddTerms"));
const Quotation = React.lazy(() => import("./Pages/Quotation/Quotation"));
const AddQuotation = React.lazy(() => import("./Pages/Quotation/AddQuotation"));
const QuotationStatus = React.lazy(() => import("./Pages/Quotation/QuotationStatus"));
const Quotationinfavour = React.lazy(() => import("./Pages/QuotationInFavour/Quotationinfavour"));
const OrderFulfillmentDispatchReport = React.lazy(() => import("./Pages/Reports/OrderFulfillmentDispatchReport"));
const PaymentTrackingReport = React.lazy(() => import("./Pages/Reports/PaymentTrackingReport"));
const CollectionReport = React.lazy(() => import("./Pages/Reports/CollectionReport"));

const routes = [
  {
    path: "/login",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <LoginPage />
      </Suspense>
    ),
  },
  {
    path: "/",
    element: <Navigate to="/login" replace />,
  },
  {
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <PrivateRoute />
      </Suspense>
    ), // 🛡 Wrap protected routes here
    children: [
      {
        path: "/dashboard",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <DashboardLayout />
          </Suspense>
        ),
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <DashboardHome />
              </Suspense>
            ),
          },
          //
          {
            path: "itemgroup",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <ItemGroup />
              </Suspense>
            ),
          },
          {
            path: "itemgroupadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddItemGroup />
              </Suspense>
            ),
          },
          {
            path: "unit",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Unit />
              </Suspense>
            ),
          },
          {
            path: "unitadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddUnit />
              </Suspense>
            ),
          },
          {
            path: "item",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Item />
              </Suspense>
            ),
          },
          {
            path: "itemadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddItem />
              </Suspense>
            ),
          },
          {
            path: "party",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Party />
              </Suspense>
            ),
          },
          {
            path: "partyadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddParty />
              </Suspense>
            ),
          },
          {
            path: "terms",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Terms />
              </Suspense>
            ),
          },
          {
            path: "termsadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddTerms />
              </Suspense>
            ),
          },
          {
            path: "quotation",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Quotation />
              </Suspense>
            ),
          },
          {
            path: "quotationadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddQuotation />
              </Suspense>
            ),
          },
          {
            path: "quotationedit",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddQuotation />
              </Suspense>
            ),
          },
          {
            path: "quotationstatus",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <QuotationStatus />
              </Suspense>
            ),
          },
          {
            path: "quotationinfavour",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Quotationinfavour />
              </Suspense>
            ),
          },
          {
            path: "orderfulfillmentdispatchreport",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <OrderFulfillmentDispatchReport />
              </Suspense>
            ),
          },
          {
            path: "paymenttrackingreport",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <PaymentTrackingReport />
              </Suspense>
            ),
          },
          {
            path: "collectionreport",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <CollectionReport />
              </Suspense>
            ),
          },
          {
            path: "/dashboard/quotation/quotationprint",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                {<QuotationPrint />}
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
];

export default routes;
